"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupDetailForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_dropzone_1 = require("react-dropzone");
var util_1 = require("../util");
var i18n_1 = __importDefault(require("../i18n"));
var PartDateInput_1 = require("./PartDateInput");
var api_1 = require("../api");
var context_1 = require("../context");
var sentry_1 = require("../sentry");
var ProfileIcon_1 = require("./ProfileIcon");
var imageMaxSize = 500 * 1024;
var imageTypes = ["image/png", "image/gif", "image/jpeg"];
var GroupDetailForm = function GroupDetail(_a) {
    var group = _a.group, groupLoading = _a.groupLoading, setGroupsFetchRequest = _a.setGroupsFetchRequest;
    var isNewGroup = !group;
    var incrementErrorCount = React.useContext(context_1.IncrementErrorCountContext);
    var _b = React.useState(group ? __assign({}, group) : { id: "", tagName: "", name: "" }), tempGroup = _b[0], setTempGroup = _b[1];
    var _c = React.useState(0 /* GroupSavingState.Edit */), groupSavingState = _c[0], setGroupSavingState = _c[1];
    var _d = React.useState(group ? group.id : undefined), groupId = _d[0], setGroupId = _d[1];
    var setProp = genSetTempGroupProp(setTempGroup);
    var validateResult = validateGroup(tempGroup);
    var ValidationResult = genValidationResult(validateResult);
    var changed = !(0, util_1.isGroupEqual)(group, tempGroup);
    var _e = (0, react_dropzone_1.useDropzone)({
        multiple: false,
        maxSize: imageMaxSize,
        accept: imageTypes,
        onDropAccepted: function (acceptedFiles) {
            var thumbnailImageFile = acceptedFiles[0];
            var reader = new FileReader();
            reader.onload = function () {
                return setTempGroup(function (nextTempGroup) { return (__assign(__assign({}, nextTempGroup), { thumbnailImageUrl: reader.result })); });
            };
            reader.readAsDataURL(thumbnailImageFile);
            setTempGroup(function (nextTempGroup) { return (__assign(__assign({}, nextTempGroup), { thumbnailImageFile: thumbnailImageFile })); });
        },
        onDropRejected: function (files) {
            var errors = [];
            for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                var file = files_1[_i];
                if (file.size > imageMaxSize)
                    errors.push("".concat(file.name, ": ").concat(i18n_1.default.imageMaxSize));
                if (imageTypes.indexOf(file.type) === -1)
                    errors.push("".concat(file.name, ": ").concat(i18n_1.default.imageType));
            }
            alert(errors.join("\n"));
        },
    }), getRootProps = _e.getRootProps, getInputProps = _e.getInputProps;
    if (groupSavingState === 2 /* GroupSavingState.Saved */)
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: "/groups/".concat(groupId) });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: groupLoading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: groupLoading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form, { onSubmit: function (e) { return e.preventDefault(); }, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { required: true, error: !!validateResult.name, children: [(0, jsx_runtime_1.jsx)("label", { children: i18n_1.default.groupName }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { maxLength: "255", defaultValue: tempGroup.name || "", onChange: setProp("name"), placeholder: "Foobar force" }), (0, jsx_runtime_1.jsx)(ValidationResult, { prop: "name" })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { required: true, error: !!validateResult.tagName, children: [(0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "tag" }), i18n_1.default.groupTag] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { maxLength: "40", defaultValue: tempGroup.tagName || "", onChange: setProp("tagName"), placeholder: "Foobar Force" }), (0, jsx_runtime_1.jsx)(ValidationResult, { prop: "tagName" })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { error: !!validateResult.summary, children: [(0, jsx_runtime_1.jsx)("label", { children: i18n_1.default.groupSummary }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { maxLength: "70", defaultValue: tempGroup.summary || "", onChange: setProp("summary"), placeholder: "Summary for twitter card" }), (0, jsx_runtime_1.jsx)(ValidationResult, { prop: "summary" })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { children: [(0, jsx_runtime_1.jsx)("label", { children: i18n_1.default.image }), (0, jsx_runtime_1.jsxs)("div", __assign({}, getRootProps(), { children: [(0, jsx_runtime_1.jsx)("input", __assign({}, getInputProps())), (0, jsx_runtime_1.jsx)("p", { children: i18n_1.default.dropOrChooseFile }), (0, jsx_runtime_1.jsxs)("p", { children: ["(", i18n_1.default.imageMaxSize, " ", i18n_1.default.imageType, ")"] }), tempGroup.thumbnailImageUrl && (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { size: "medium", src: tempGroup.thumbnailImageUrl })] })), tempGroup.thumbnailImageFile && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { type: "button", onClick: function () {
                                        return setTempGroup(__assign(__assign({}, tempGroup), { thumbnailImageFile: undefined, thumbnailImageUrl: group ? group.thumbnailImageUrl : undefined }));
                                    }, children: i18n_1.default.reset }))] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { children: [(0, jsx_runtime_1.jsx)("label", { children: i18n_1.default.groupProfile }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.TextArea, { rows: "7", defaultValue: tempGroup.profile || "", onChange: setProp("profile") })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { children: [(0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(ProfileIcon_1.ProfileIcon, { iconFor: "site" }), i18n_1.default.site] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { maxLength: "255", defaultValue: tempGroup.site || "", onChange: setProp("site"), placeholder: "https://example.com/" })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { children: [(0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(ProfileIcon_1.ProfileIcon, { iconFor: "twitter" }), i18n_1.default.twitter] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { maxLength: "15", defaultValue: tempGroup.twitter || "", onChange: setProp("twitter"), icon: "at", iconPosition: "left" })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { children: [(0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(ProfileIcon_1.ProfileIcon, { iconFor: "discord" }), i18n_1.default.discordInviteUrl] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { maxLength: "255", defaultValue: tempGroup.discordInviteUrl || "", onChange: setProp("discordInviteUrl"), placeholder: "https://discord.gg/ExAmPle" }), (0, jsx_runtime_1.jsx)("p", { children: i18n_1.default.discordInviteUrlShouldNotExpire })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { children: [(0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(ProfileIcon_1.ProfileIcon, { iconFor: "birthday" }), i18n_1.default.groupCreatedAt] }), (0, jsx_runtime_1.jsx)(GroupCreatedAtPartDateInput, { tempGroup: tempGroup, setTempGroup: setTempGroup }), (0, jsx_runtime_1.jsx)("p", { children: i18n_1.default.ambiguousToBlank })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { onClick: function () {
                                return saveGroup(isNewGroup, tempGroup, setGroupsFetchRequest, setGroupSavingState, setGroupId, incrementErrorCount);
                            }, color: changed ? "red" : "green", disabled: !validateResult.valid ||
                                !changed ||
                                groupSavingState !== 0 /* GroupSavingState.Edit */ ||
                                groupLoading, children: changed ? (isNewGroup ? i18n_1.default.create : i18n_1.default.update) : i18n_1.default.saved })] })] }) }));
};
exports.GroupDetailForm = GroupDetailForm;
function validateGroup(group) {
    var result = {};
    if (group.name == null || group.name.length === 0)
        result.name = { required: true };
    if (group.name && group.name.length > 255)
        result.name = { overMaxLength: true };
    if (group.summary && group.summary.length > 70)
        result.summary = { overMaxLength: true };
    if (group.tagName == null || group.tagName.length === 0)
        result.tagName = { required: true };
    if (group.tagName && group.tagName.length > 40)
        result.tagName = { overMaxLength: true };
    result.valid = !Object.keys(result).length;
    return result;
}
function genValidationResult(result) {
    return function ValidationResult(_a) {
        var prop = _a.prop;
        var propResult = result[prop];
        if (propResult) {
            if (propResult.required)
                return (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Message, { error: true, content: i18n_1.default.required });
            if (propResult.overMaxLength)
                return (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Message, { error: true, content: i18n_1.default.overMaxLength });
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
}
function genSetTempGroupProp(setTempGroup) {
    return function setTempGroupProp(prop) {
        return function setProp(e, _a) {
            var value = _a.value;
            setTempGroup(function (tempGroup) {
                var _a;
                return (__assign(__assign({}, tempGroup), (_a = {}, _a[prop] = value, _a)));
            });
        };
    };
}
var GroupCreatedAtPartDateInput = function (_a) {
    var tempGroup = _a.tempGroup, setTempGroup = _a.setTempGroup;
    var date = tempGroup.groupCreatedAtPartTime;
    var setDate = function (newDate) {
        return setTempGroup(__assign(__assign({}, tempGroup), { groupCreatedAt: (0, util_1.timePropsToDateString)(newDate), groupCreatedAtPartTime: newDate }));
    };
    return (0, jsx_runtime_1.jsx)(PartDateInput_1.PartDateInput, { date: date, setDate: setDate });
};
function saveGroup(isNewGroup, tempGroup, setGroupsFetchRequest, setGroupSavingState, setGroupId, incrementErrorCount) {
    return __awaiter(this, void 0, void 0, function () {
        var id, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 8]);
                    setGroupSavingState(1 /* GroupSavingState.Saving */);
                    id = tempGroup.id;
                    if (!isNewGroup) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, api_1.createGroup)(tempGroup)];
                case 1:
                    id = _a.sent();
                    setGroupId(id);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, api_1.updateGroup)(tempGroup)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    if (!tempGroup.thumbnailImageFile) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, api_1.saveGroupThumbnail)(id, tempGroup.thumbnailImageFile)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    setGroupSavingState(2 /* GroupSavingState.Saved */);
                    return [3 /*break*/, 8];
                case 7:
                    e_1 = _a.sent();
                    (0, sentry_1.captureException)(e_1);
                    incrementErrorCount();
                    alert("".concat(i18n_1.default.group, "\n").concat(e_1));
                    setGroupSavingState(0 /* GroupSavingState.Edit */);
                    return [3 /*break*/, 8];
                case 8:
                    setGroupsFetchRequest(true);
                    return [2 /*return*/];
            }
        });
    });
}
